<script>
  import News from '@components/List/News'
  import Bulletin from '@components/List/Bulletin'
  import DialogLogin from '@components/Dialog/Login';
  import DialogDealer from '@components/Dialog/Dealer';
  import DialogDealerGroup from '@components/Dialog/DealerGroup';
  import { authComputed } from '@store/helpers'

  export default {
    components: {
      News,
      Bulletin,
      DialogLogin,
      DialogDealer,
      DialogDealerGroup
    },
    props: {
      promotionList: {
        type: Array,
        default: () => {
          return []
        },
      },
      bulletinList: {
        type: Array,
        default: () => {
          return []
        },
      }
    },
    data() {
      return {
        newsActiveName: 'promotion',
        isDialogLoginVisible: false,
        isDialogDealerVisible: false,
        isDialogDealerGroupVisible: false,
        callbackLogin: () => {
        },
      }
    },
    computed: {
      ...authComputed,
    },
    methods: {
      formattedList(list) {
        return list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands[0],
          extrafields: item.extrafields,
          to: {
            name: 'news-item',
            params: {
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
      goToView(item) {
        const loggedInFn = () => {
          this.isDialogLoginVisible = false;
          this.$nextTick(() => {
            if(item.isdealer && this.currentMember?.groupId !== 6) {
              this.isDialogDealerGroupVisible = true
            } else {
              this.$router.push(item.to)
            }
          })
        };

        if(this.loggedIn) {
          loggedInFn()
        } else {
          this.callbackLogin = () => {
            loggedInFn()
          };
          this.isDialogDealerVisible = true
        }
      },
      showLogin(val) {
        this.isDialogLoginVisible = val
        this.isDialogDealerVisible = false
      }
    }
  }
</script>

<template>
  <div class="section SectionNews">
    <div class="container">
      <h2 class="Home-title"
      ><span class="Home-title__small">即時掌握最新IT情報</span>
        <span class="Home-title__big">最新消息</span>
      </h2>
      <div :class="$style.news">
        <el-tabs v-model="newsActiveName" stretch class="isStyleBase">
          <el-tab-pane label="促銷訊息" name="promotion">
            <News
              v-if="formattedList(promotionList).length"
              :list="formattedList(promotionList)"
              link-type="list"
              @goTo="goToView"
            />
            <div v-else>點選下方看更多促銷訊息</div>
          </el-tab-pane>
          <el-tab-pane label="品牌新訊" name="bulletin">
            <Bulletin
              v-if="formattedList(bulletinList).length"
              :list="formattedList(bulletinList)"
              link-type="list"
              @goTo="goToView"
            />
            <div v-else>點選下方看更多品牌新訊</div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="text-center">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'news-category', params: { categoryAlias: newsActiveName } }"
        >
          查看所有{{
            newsActiveName === 'bulletin'
              ? '品牌新訊'
              : '促銷訊息'
          }}
        </BaseButton>
      </div>
    </div>
    <DialogDealerGroup
      :visible.sync="isDialogDealerGroupVisible"
    />
    <DialogDealer
      :visible.sync="isDialogDealerVisible"
      @isShowlogin="showLogin"
    />
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </div>
</template>

<style lang="scss" module>
  .news {
    margin-bottom: 1.75rem;
  }
</style>
